import { Flex } from "@/common/styles";
import styled from "styled-components";

export const ActionsContainer = styled(Flex)`
  border-top: 1px solid #ddd;
  width: 100%;
  padding: 10px;
  margin-top: 15px;
  gap: 15px;
  justify-content: flex-end;
`;
